export default "__VITE_ASSET__BTG2e29v__"